define("ROOM4.CCAProductGallery.CCAProductGallery.PackageItemQuote.Model", [
  "ProductList.Model",
  "ProductList.Item.Model",
  "Profile.Model",
  "Session",
  "Backbone",
  "jQuery",
  "Utils",
  "underscore",
], function (
  ProductListModel,
  ProductListItemModel,
  ProfileModel,
  Session,
  Backbone,
  jQuery,
  Utils,
  _
) {
  "use strict";

  function toPositiveQuantity(value) {
    var parsed = parseInt(value, 10);

    return !isNaN(parsed) && parsed > 0 ? parsed : 1;
  }

  function getItemTitle(component) {
    return (
      component.displayname ||
      component.itemname ||
      component.itemnumber ||
      Utils.translate("Package Item")
    );
  }

  function hasOptions(options) {
    if (!options) {
      return false;
    }

    if (_.isArray(options)) {
      return !!options.length;
    }

    if (_.isObject(options)) {
      return !!_.keys(options).length;
    }

    return false;
  }

  function areOptionsEqual(leftOptions, rightOptions) {
    if (!hasOptions(leftOptions) && !hasOptions(rightOptions)) {
      return true;
    }

    return _.isEqual(leftOptions, rightOptions);
  }

  function getQuoteItems(productListJson) {
    productListJson.items = productListJson.items || [];

    return productListJson.items;
  }

  return Backbone.Model.extend({
    defaults: {
      isAddingToQuote: false,
      isAddedToQuote: false,
      error: null,
    },

    initialize: function initialize(attributes, options) {
      options = options || {};

      this.container = options.container;
      this.component = options.component || {};
      this.quantityProvider = options.quantityProvider;
      this.profile_model = ProfileModel.getInstance();
    },

    getQuantity: function getQuantity() {
      if (this.quantityProvider) {
        return toPositiveQuantity(this.quantityProvider());
      }

      return toPositiveQuantity(this.get("quantity"));
    },

    isQuotable: function isQuotable() {
      return !!(
        this.container &&
        this.container.ProductListModule &&
        this.container.ProductListModule.Utils &&
        this.container.ProductListModule.Utils.isProductListEnabled &&
        this.container.ProductListModule.Utils.isProductListEnabled()
      );
    },

    validateLogin: function validateLogin() {
      var currentTouchpoint;
      var params;
      var loginUrl;

      this.profile_model = this.profile_model || ProfileModel.getInstance();

      if (this.profile_model && this.profile_model.get("isLoggedIn") === "T") {
        return true;
      }

      currentTouchpoint =
        this.container && this.container.getConfig
          ? this.container.getConfig().currentTouchpoint
          : "home";
      params = {
        origin: currentTouchpoint || "home",
        origin_hash: encodeURIComponent(Backbone.history.fragment || ""),
      };
      loginUrl =
        Session && Session.get ? Session.get("touchpoints.login") : "";

      if (loginUrl) {
        window.location.href = Utils.addParamsToUrl(loginUrl, params);
      }

      return false;
    },

    getQuoteProductList: function getQuoteProductList() {
      if (
        this.container &&
        this.container.ProductListModule &&
        this.container.ProductListModule.Utils &&
        this.container.ProductListModule.Utils.getRequestAQuoteProductList
      ) {
        return this.container.ProductListModule.Utils.getRequestAQuoteProductList();
      }

      return null;
    },

    createProductListLine: function createProductListLine() {
      var itemId = parseInt(this.get("itemId"), 10);
      var itemTitle = getItemTitle(this.component);

      return new ProductListItemModel({
        item: {
          internalid: itemId,
          itemid: this.component.itemnumber || "",
          displayname: itemTitle,
          _name: itemTitle,
          _minimumQuantity: 1,
          _matrixParent: {},
          options: [],
        },
        options: [],
        quantity: this.getQuantity(),
        priority: {
          id: "2",
          name: "medium",
        },
      });
    },

    findItemInQuote: function findItemInQuote(productListJson, productListLine) {
      var productListLineJson = productListLine.toJSON();
      var items = (productListJson && productListJson.items) || [];

      return _.find(items, function (productListLineAux) {
        return (
          productListLineAux.item &&
          parseInt(productListLineAux.item.internalid, 10) ===
            productListLineJson.item.internalid &&
          areOptionsEqual(productListLineJson.options, productListLineAux.options)
        );
      });
    },

    addItemToQuote: function addItemToQuote(productListJson, productListLine) {
      var self = this;
      var deferred = jQuery.Deferred();

      productListLine.set("productList", {
        id: productListJson.internalid,
      });
      productListLine.set("quantity", this.getQuantity());

      productListLine
        .save(null, {
          validate: false,
        })
        .done(function (createdProductListLineJson) {
          deferred.resolve(createdProductListLineJson);
        })
        .fail(function (error) {
          self.set({
            error: error,
            isAddingToQuote: false,
          });
          deferred.reject(error);
        });

      return deferred.promise();
    },

    addItemToQuoteList: function addItemToQuoteList(
      productListJson,
      productListLine
    ) {
      var deferred = jQuery.Deferred();
      var productListLineJson;

      this.addItemToQuote(productListJson, productListLine)
        .done(function (createdProductListLineJson) {
          productListLineJson = productListLine.toJSON();
          productListLineJson.internalid =
            createdProductListLineJson &&
            createdProductListLineJson.internalid
              ? createdProductListLineJson.internalid
              : productListLineJson.internalid;

          getQuoteItems(productListJson).push(productListLineJson);
          deferred.resolve(productListLineJson);
        })
        .fail(function (error) {
          deferred.reject(error);
        });

      return deferred.promise();
    },

    updateItemInQuote: function updateItemInQuote(itemInList, productListLine) {
      var self = this;
      var deferred = jQuery.Deferred();
      var quantityToAdd = this.getQuantity();
      var currentQuantity = parseInt(itemInList.quantity, 10);
      var productListItemModel = new ProductListItemModel({
        internalid: itemInList.internalid,
      });

      productListItemModel.set(
        "quantity",
        (isNaN(currentQuantity) ? 0 : currentQuantity) + quantityToAdd
      );
      productListItemModel.set("options", productListLine.get("options"));

      productListItemModel
        .save()
        .done(function () {
          deferred.resolve();
        })
        .fail(function (error) {
          self.set({
            error: error,
            isAddingToQuote: false,
          });
          deferred.reject(error);
        });

      return deferred.promise();
    },

    updateItemInQuoteList: function updateItemInQuoteList(
      itemInList,
      productListLine
    ) {
      var deferred = jQuery.Deferred();
      var quantityToAdd = this.getQuantity();
      var currentQuantity = parseInt(itemInList.quantity, 10);

      this.updateItemInQuote(itemInList, productListLine)
        .done(function () {
          itemInList.quantity =
            (isNaN(currentQuantity) ? 0 : currentQuantity) + quantityToAdd;
          itemInList.options = productListLine.get("options");
          deferred.resolve(itemInList);
        })
        .fail(function (error) {
          deferred.reject(error);
        });

      return deferred.promise();
    },

    notifyQuoteChanged: function notifyQuoteChanged() {
      var QuoteImprovementModel;
      var quoteImprovementModel;
      var change;

      if (typeof require !== "function") {
        return;
      }

      try {
        QuoteImprovementModel = require(
          "SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.Model"
        );

        if (!QuoteImprovementModel || !QuoteImprovementModel.getInstance) {
          return;
        }

        quoteImprovementModel = QuoteImprovementModel.getInstance();
        change = !quoteImprovementModel.get("QuoteChanged");

        quoteImprovementModel.set("QuoteChanged", change);
      } catch (error) {
        return;
      }
    },

    getOrCreateQuoteProductList: function getOrCreateQuoteProductList() {
      var productListPromise = this.getQuoteProductList();
      var deferred = jQuery.Deferred();

      if (!productListPromise || !productListPromise.done) {
        deferred.reject();
        return deferred.promise();
      }

      productListPromise
        .done(function (productListJson) {
          var productListModel;

          if (productListJson.internalid) {
            deferred.resolve(productListJson);
            return;
          }

          productListModel = new ProductListModel(productListJson);

          productListModel.save().done(function (createdProductListJson) {
            deferred.resolve(createdProductListJson);
          }).fail(function (error) {
            deferred.reject(error);
          });
        })
        .fail(function (error) {
          deferred.reject(error);
        });

      return deferred.promise();
    },

    addToQuote: function addToQuote() {
      var self = this;
      var itemId = parseInt(this.get("itemId"), 10);
      var deferred = jQuery.Deferred();

      function rejectAddToQuote(error) {
        deferred.reject(error);
      }

      function completeAddToQuote() {
        self.notifyQuoteChanged();
        self.set({
          isAddingToQuote: false,
          isAddedToQuote: true,
        });
        deferred.resolve();
      }

      function failAddToQuote(error) {
        self.set({
          error: error,
          isAddingToQuote: false,
        });
        deferred.reject(error);
      }

      function addToQuoteList(productListJson) {
        var productListLine = self.createProductListLine();
        var itemPresentInList;

        itemPresentInList = self.findItemInQuote(
          productListJson,
          productListLine
        );

        if (itemPresentInList) {
          self
            .updateItemInQuoteList(itemPresentInList, productListLine)
            .done(completeAddToQuote)
            .fail(failAddToQuote);
        } else {
          self
            .addItemToQuoteList(productListJson, productListLine)
            .done(completeAddToQuote)
            .fail(failAddToQuote);
        }
      }

      if (!itemId || isNaN(itemId) || !this.isQuotable()) {
        rejectAddToQuote();
        return deferred.promise();
      }

      if (!this.validateLogin()) {
        rejectAddToQuote();
        return deferred.promise();
      }

      this.set({
        isAddingToQuote: true,
        error: null,
      });

      this.getOrCreateQuoteProductList().done(addToQuoteList).fail(failAddToQuote);

      return deferred.promise();
    },

    addToQuoteProductList: function addToQuoteProductList(productListJson) {
      var self = this;
      var itemId = parseInt(this.get("itemId"), 10);
      var deferred = jQuery.Deferred();
      var productListLine;
      var itemPresentInList;

      function completeAddToQuote() {
        self.set({
          isAddingToQuote: false,
          isAddedToQuote: true,
        });
        deferred.resolve(productListJson);
      }

      function failAddToQuote(error) {
        self.set({
          error: error,
          isAddingToQuote: false,
        });
        deferred.reject(error);
      }

      if (
        !itemId ||
        isNaN(itemId) ||
        !productListJson ||
        !productListJson.internalid
      ) {
        deferred.reject();
        return deferred.promise();
      }

      this.set({
        isAddingToQuote: true,
        error: null,
      });

      productListLine = this.createProductListLine();
      itemPresentInList = this.findItemInQuote(productListJson, productListLine);

      if (itemPresentInList) {
        this.updateItemInQuoteList(itemPresentInList, productListLine)
          .done(completeAddToQuote)
          .fail(failAddToQuote);
      } else {
        this.addItemToQuoteList(productListJson, productListLine)
          .done(completeAddToQuote)
          .fail(failAddToQuote);
      }

      return deferred.promise();
    },

    getQuoteLineKey: function getQuoteLineKey() {
      var productListLine = this.createProductListLine();
      var productListLineJson = productListLine.toJSON();

      return [
        productListLineJson.item && productListLineJson.item.internalid,
        JSON.stringify(productListLineJson.options || []),
      ].join("|");
    },

    cloneWithQuantity: function cloneWithQuantity(quantity) {
      return new this.constructor(
        {
          itemId: this.get("itemId"),
          quantity: quantity,
        },
        {
          container: this.container,
          component: this.component,
        }
      );
    },
  });
});
